import React from 'react';
import { MapPin, Phone, Mail, Clock, Facebook, Instagram, Twitter } from 'lucide-react';

const Footer = ({ onPageChange }) => {
  const handleLinkClick = (page) => {
    if (onPageChange) {
      onPageChange(page);
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          {/* Company Info */}
          <div className="footer-section">
            <h3>La Ferme À L'Ancienne</h3>
            <div className="footer-logos" style={{ display: 'flex', gap: '1.5rem', marginBottom: '1.5rem', alignItems: 'center', flexWrap: 'wrap' }}>
              <img 
                src="/images/AB.png" 
                alt="Certification Agriculture Biologique - Logo AB" 
                style={{ height: '80px', width: 'auto' }}
              />
              <img 
                src="/images/VACHES.png" 
                alt="Élevage bovin bio - La Ferme À L'Ancienne" 
                style={{ height: '80px', width: 'auto' }}
              />
            </div>
            <div className="social-links">
              <a href="https://facebook.com/boucherie-maudet" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <Facebook size={20} />
              </a>
              <a href="https://instagram.com/boucherie-maudet" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <Instagram size={20} />
              </a>
              <a href="https://twitter.com/boucherie-maudet" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                <Twitter size={20} />
              </a>
            </div>
          </div>

          {/* Contact Info */}
          <div className="footer-section">
            <h4>Nous Contacter</h4>
            <div className="contact-info">
              <div className="contact-item">
                <MapPin size={18} />
                <div>
                  <p>1451 rue de raillon</p>
                  <p>72800 Le Lude</p>
                </div>
              </div>
              <div className="contact-item">
                <div style={{ width: '18px', flexShrink: 0 }}></div>
                <div>
                  <p style={{ marginBottom: '8px', fontWeight: 'bold' }}>Jérôme Maudet</p>
                </div>
              </div>
              <div className="contact-item">
                <Phone size={18} style={{ flexShrink: 0, marginTop: '2px' }} />
                <p style={{ margin: 0 }}>06 37 90 34 63</p>
              </div>
              <div className="contact-item">
                <Mail size={18} style={{ flexShrink: 0, marginTop: '2px' }} />
                <p style={{ margin: 0 }}>eric72800@hotmail.fr</p>
              </div>
              <div className="contact-item">
                <div style={{ width: '18px', flexShrink: 0 }}></div>
                <div>
                  <p style={{ marginBottom: '0', fontWeight: 'bold' }}>Drogix Jérémy</p>
                </div>
              </div>
              <div className="contact-item">
                <Phone size={18} style={{ flexShrink: 0, marginTop: '2px' }} />
                <p style={{ margin: 0 }}>06 17 30 32 40</p>
              </div>
              <div className="contact-item">
                <Mail size={18} style={{ flexShrink: 0, marginTop: '2px' }} />
                <p style={{ margin: 0 }}>jeje-49@hotmail.fr</p>
              </div>
            </div>
          </div>

          {/* Opening Hours */}
          <div className="footer-section">
            <h4>Horaires d'Ouverture</h4>
            <div className="opening-hours">
              <div className="hours-item">
                <Clock size={18} />
                <div>
                  <p><strong>Mercredi - Vendredi</strong></p>
                  <p>14h00 - 20h00</p>
                </div>
              </div>
              <div className="hours-item">
                <Clock size={18} />
                <div>
                  <p><strong>Samedi</strong></p>
                  <p>8h30 - 12h30</p>
                  <p>14h00 - 19h00</p>
                </div>
              </div>
              <div className="hours-item">
                <Clock size={18} />
                <div>
                  <p><strong>Dimanche - Mardi</strong></p>
                  <p>Fermé</p>
                </div>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h4>Liens Rapides</h4>
            <ul className="quick-links">
              <li><button onClick={() => handleLinkClick('accueil')}>Accueil</button></li>
              <li><button onClick={() => handleLinkClick('produits')}>Nos Produits</button></li>
              <li><button onClick={() => handleLinkClick('histoire')}>Notre Histoire</button></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>&copy; 2024 La Ferme À L'Ancienne. Tous droits réservés.</p>
            <div className="footer-links">
              <a href="#mentions">Mentions légales</a>
              <a href="#privacy">Politique de confidentialité</a>
              <a href="#cgv">CGV</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;